import * as initialState from '../initialState.tsx';

const persist = (state = initialState, action) => {

    if(action.type == 'persist/REHYDRATE'){
        return state;
    } else if(action.type == '@@router/LOCATION_CHANGE') {
        return state;
    } else return state;
};

export default persist;
